/* eslint-disable camelcase */
/* eslint-disable max-lines */
/* eslint-disable max-len */
import { useStorage, useValidation } from './helpers.js';

const { $ } = window;

$(document).ready(function() {
    $('select.custom-select').select2();

    $('#invoice-request').change(function() {
        $(this).prop('checked')
            ? $('.js-inoice-fields').slideDown()
            : $('.js-inoice-fields').slideUp();
    });

    if (useStorage().get('invoice[request]') == 'true') {
        $('.js-inoice-fields').slideDown();
    }

    const { isValidName, isValidPhone, isValidZip } = useValidation();

    $.validator.addMethod('isValidName', function(value) {
        return isValidName(value);
    });

    $.validator.addMethod('isValidPhone', function(value) {
        return isValidPhone(value);
    });

    $.validator.addMethod('isValidZip', function(value) {
        return !$('#invoice-request').is(':checked') || isValidZip(value);
    });

    $('#personalInfoForm').validate({
        errorPlacement: function() {},
        ignore: '',
        invalidHandler: function(event, validator) {
            Object.keys(validator.errorMap).forEach(key => {
                $(`span.field-error[data-error="${key}"]`).text(validator.errorMap[key]).removeClass('hidden');
            });
        },
        messages: {
            'client[email]': {
                email: 'Παρακαλούμε εισάγετε μια έγκυρη μορφή Email',
                required: 'Το πεδίο είναι υποχρεωτικό',
            },
            'client[name]': {
                isValidName: 'Παρακαλώ εισάγετε ένα έγκυρο Όνομα',
                required: 'Το πεδίο είναι υποχρεωτικό',
            },
            'client[phone]': {
                isValidPhone: 'Παρακαλώ εισάγετε έναν έγκυρο αριθμό κινητού τηλεφώνου',
                required: 'Το πεδίο είναι υποχρεωτικό',
            },
            'client[surname]': {
                isValidName: 'Παρακαλώ εισάγετε ένα έγκυρο Επώνυμο',
                required: 'Το πεδίο είναι υποχρεωτικό',
            },
            'invoice[address]': 'Το πεδίο είναι υποχρεωτικό',
            'invoice[city]': 'Το πεδίο είναι υποχρεωτικό',
            'invoice[doy]': 'Το πεδίο είναι υποχρεωτικό',
            'invoice[name]': 'Το πεδίο είναι υποχρεωτικό',
            'invoice[occupation]': 'Το πεδίο είναι υποχρεωτικό',
            'invoice[vat]': 'ΤΤο πεδίο είναι υποχρεωτικότικό',
            'invoice[zipcode]': {
                isValidZip: 'Παρακαλώ εισάγετε έναν έγκυρο Τ.Κ.',
                required: 'Το πεδίο είναι υποχρεωτικό',
            },
        },
        rules: {
            'client[email]': {
                email: true,
                required: true,
            },
            'client[name]': {
                isValidName: true,
                required: true,
            },
            'client[phone]': {
                isValidPhone: true,
                required: true,
            },
            'client[surname]': {
                isValidName: true,
                required: true,
            },
            'invoice[address]': {
                required: '#invoice-request:checked',
            },
            'invoice[city]': {
                required: '#invoice-request:checked',
            },
            'invoice[doy]': {
                required: '#invoice-request:checked',
            },
            'invoice[name]': {
                required: '#invoice-request:checked',
            },
            'invoice[occupation]': {
                required: '#invoice-request:checked',
            },
            'invoice[vat]': {
                required: '#invoice-request:checked',
            },
            'invoice[zipcode]': {
                isValidZip: true,
                required: '#invoice-request:checked',
            },
        },
        submitHandler: function() {
            window.location = '/step4';
        },
    });
});
